import styled from 'styled-components';
import { MAIN_BLUE } from '@espacePro/constants/admin-theme';

const Link = styled.a`
  color: ${MAIN_BLUE};
  text-decoration: none;
  
  &:hover,
  &:focus {
    color: ${MAIN_BLUE};
    text-decoration: underline;
  }
`;

export { Link };
